<template>
  <div id="doswiadczenie" class="experience">
    <h1 class="text-center mb-4">Obszary praktyki</h1>
    <v-row class="specializations" justify="center" align="center">
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('zamowieniaPubliczne')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text">euro</v-icon>
          </div>
          <v-divider />
          <h4 class="text-center">Zamówienia publiczne</h4>
        </div>
      </v-col>
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('pppIKoncesje')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text">business</v-icon>
          </div>
          <v-divider />
          <h4 class="text-center">PPP i koncesje</h4>
        </div>
      </v-col>
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('wsparcieBranzy')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text">mdi-lightbulb-on-outline</v-icon>
          </div>
          <v-divider />
          <h4 class="text-center">Wsparcie branży kreatywnej i e-commerce</h4>
        </div>
      </v-col>
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('umowyGospodarcze')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text"
              >mdi-file-document-edit-outline</v-icon
            >
          </div>
          <v-divider />
          <h4 class="text-center">Umowy gospodarcze</h4>
        </div>
      </v-col>
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('stalaObsluga')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text">trending_up</v-icon>
          </div>
          <v-divider />
          <h4 class="text-center">Stała obsługa firm</h4>
        </div>
      </v-col>
      <v-col
        cols="12"
        md
        class="specialization"
        @click="toggleSpecialization('szkolenia')"
      >
        <div class="specialization__content">
          <div class="text-center">
            <v-icon large class="accent--text">school</v-icon>
          </div>
          <v-divider />
          <h4 class="text-center">Szkolenia</h4>
        </div>
      </v-col>
    </v-row>

    <div
      v-show="toggledSpecialization == 'zamowieniaPubliczne'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>ZAM&Oacute;WIENIA PUBLICZNE</b></p>
      <p>
        Zam&oacute;wienia publiczne to wiodąca specjalizacja naszej Kancelarii.
        Pomagamy wykonawcom wygrywać przetargi, a zamawiającym dokonywać mądrych
        zakup&oacute;w w zgodzie z przepisami prawa.
      </p>
      <p>
        Jeżeli jesteś wykonawcą zam&oacute;wień publicznych, doskonale wiesz jak
        wymagająca i trudna bywa wsp&oacute;łpraca z sektorem publicznym. Nawet
        drobny błąd może kosztować wykluczeniem z przetargu lub dotkliwą karą
        umowną przy realizacji kontraktu.
      </p>
      <p>
        Wspieramy wykonawc&oacute;w zam&oacute;wień publicznych<span
          >&nbsp;</span
        ><b>na każdym etapie relacji z zamawiającymi</b
        ><span>&nbsp;</span>&ndash; od analizy dokumentacji przetargowej, przez
        złożenie oferty, reprezentację przed Krajową Izbą Odwoławczą, aż po
        skuteczną realizację umowy. Pomagamy także<span>&nbsp;</span
        ><b>zamawiającym</b><span>&nbsp;</span>w prowadzeniu postępowań o
        udzielenie zam&oacute;wienia publicznego.
      </p>
      <p>
        <b
          >Więcej dowiesz się z naszego firmowego bloga:
          <a href="http://www.wygrajwkio.pl">www.wygrajwKIO.pl</a></b
        >
      </p>
    </div>

    <div
      v-show="toggledSpecialization == 'pppIKoncesje'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>PPP &amp; KONCESJE</b></p>
      <p>
        Aktywnie pomagamy w realizacji ważnych inwestycji publicznych w oparciu
        o<span>&nbsp;</span
        ><b
          >modele partnerstwa publiczno-prywatnego oraz koncesji na roboty
          budowlane lub usługi</b
        >. Nasi eksperci jako pierwsi w Polsce brali udział w<span>&nbsp;</span
        ><b>pilotażowych projektach PPP</b><span>&nbsp;</span>jeszcze zanim
        wykorzystanie tej formuły stało się bardziej powszechne. Wspieramy
        sektor publiczny w działaniach analitycznych i procedurze wyłonienia
        partnera prywatnego, zaś przedsiębiorcom doradzamy w toku negocjacji z
        zamawiającym pracując nad optymalnym kształtem ostatecznej umowy.
      </p>
    </div>

    <div
      v-show="toggledSpecialization == 'wsparcieBranzy'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>WSPARCIE BRANŻY KREATYWNEJ I E-COMMERCE</b></p>
      <p>
        Jak sama nazwa wskazuje, branża kreatywna ma kreować. Swoje
        bezpieczeństwo prawne zostaw nam.<span>&nbsp;</span
        ><b>Ochronimy Twoje pomysły i know-how</b>, zabezpieczymy<span
          >&nbsp;</span
        ><b>prawa autorskie</b>, stworzymy<span>&nbsp;</span
        ><b>bezpieczne umowy</b><span>&nbsp;</span>z klientami i dostawcami, a
        proces obsługi lub sprzedaży ukształtujemy w zgodzie ze wszystkimi<span
          >&nbsp;</span
        ><b>wymogami prawa</b><span>&nbsp;</span>w tym zakresie.
        Szczeg&oacute;lnie polecamy się<span>&nbsp;</span
        ><b>pracowniom architektonicznym i tw&oacute;rcom internetowym</b>.
      </p>
    </div>

    <div
      v-show="toggledSpecialization == 'umowyGospodarcze'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>UMOWY GOSPODARCZE</b></p>
      <p>
        Choć może Ci się wydawać, że w swoim biznesowym otoczeniu
        wsp&oacute;łpracujesz wyłącznie z zaufanymi podmiotami, pamiętaj, że
        Twoja ocena może czasami okazać się błędna.<span>&nbsp;</span
        ><b
          >Dobre umowy to podstawa bezpieczeństwa i spokojnego snu każdego
          przedsiębiorcy. Pisze się je na złe, a nie dobre czasy</b
        >. Życzymy Ci tylko tych dobrych, ale chętnie pomożemy w zabezpieczeniu
        Twoich interes&oacute;w w sytuacji kryzysowej. Tworzymy umowy,
        weryfikujemy kontrakty, dbamy o Tw&oacute;j komfort w relacjach
        biznesowych.
      </p>
    </div>

    <div
      v-show="toggledSpecialization == 'stalaObsluga'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>STAŁA OBSŁUGA FIRM</b></p>
      <p>
        Sami prowadzimy biznes i wiemy jak ważną kwestią jest w nim<span
          >&nbsp;</span
        ><b>bezpieczeństwo prawne</b>. Wychodzimy z założenia, że w działalności
        gospodarczej &ndash; jak w życiu &ndash; lepiej zapobiegać niż leczyć.
        Owszem, pomożemy Ci także w procesie sądowym, ale dużo bardziej wolimy
        odpowiednio wcześniej podejmować działania, dzięki kt&oacute;rym
        sp&oacute;r w og&oacute;le nie powstanie. Dlatego jesteśmy zwolennikami
        rozwiązań, kt&oacute;re świadomie wdrażane pozwolą Ci efektywnie i bez
        obaw funkcjonować w rzeczywistości gospodarczej i realizować cele
        biznesowe.
      </p>
      <p>
        <b>Zapewniamy stałą obsługę prawną przedsiębiorcom</b>. Negocjujemy
        kontrakty, zabezpieczamy interes klienta w relacji z kontrahentami,
        chronimy pomysły, tworzymy ramy prawne dla proces&oacute;w i
        organizacji.
      </p>
    </div>

    <div
      v-show="toggledSpecialization == 'szkolenia'"
      class="specialization-result pt-10 pb-5"
    >
      <p><b>SZKOLENIA</b></p>
      <p>
        Damian Michalak, założyciel Kancelarii, dzieli się swoją wiedzą i
        doświadczeniem na szkoleniach z<span>&nbsp;</span
        ><b>zakresu zam&oacute;wień publicznych, PPP i ochrony know-how</b>.
        Setki godzin na sali szkoleniowej, wsp&oacute;łpraca z renomowanymi
        firmami z branży szkoleniowej gwarantują najwyższy poziom zajęć &ndash;
        zawsze realizowanych zgodnie z założeniem: minimum teorii, maksimum
        praktyki i dużo humoru. Zapraszamy!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Specializations',
  data() {
    return {
      exampleToggled: false,
      toggledSpecialization: '',
    };
  },
  methods: {
    toggleSpecialization(specialization) {
      if (this.toggledSpecialization == specialization) {
        this.toggledSpecialization = '';
      } else {
        this.toggledSpecialization = specialization;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.experience {
  background-color: #afafaf;
  width: 100vw;
  padding: 30px;
  position: relative;
  left: 50%;
  margin-left: -50vw;
  // margin-left: -182px;
}
.specializations {
  max-width: 1100px;
  margin: auto;
}
.specialization {
  vertical-align: middle;
  margin: 4px;
  transition: all 0.3s;
  // border-radius: 5px;
  cursor: pointer;
  background-color: rgb(214, 214, 214);
}
.specialization:hover {
  background-color: #c0919e;
}
.specialization__content {
  min-height: 200px;
  padding-top: 40px;
  position: relative;
  height: 100%;
  // transform: translateY(70%);
}
.specialization__content h4 {
  text-align: center;
  margin-top: 15px;
  // position: absolute;
  // width: 100%;
}
.specialization__content .v-divider {
  margin-top: 30px;
}

.specialization-result {
  color: white;
  max-width: 1100px;
  margin: auto;
  text-align: justify;
}
</style>
